import { render, staticRenderFns } from "./AiGeneratedAllCandidates.vue?vue&type=template&id=1c720f0b&scoped=true&"
import script from "./AiGeneratedAllCandidates.vue?vue&type=script&lang=ts&"
export * from "./AiGeneratedAllCandidates.vue?vue&type=script&lang=ts&"
import style0 from "./AiGeneratedAllCandidates.vue?vue&type=style&index=0&id=1c720f0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c720f0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VList,VListItem,VMenu,VRow})
